export const SHOP_SCREEN_IMG_PLACEHOLDER =
  "https://storage.cloud.google.com/shop-screen-images-prod/placeholder.png?authuser=0";
